import { useFetchPublicApps } from '@/hooks/query/useFetchPublicApps';

export const useIsSourceConnected = (sourceId: string) => {
  const { isLoading, data } = useFetchPublicApps();

  const source = data?.find((item) => item.key === sourceId);

  return {
    isConnected: !!source,
    isLoading: isLoading,
    type: source?.category,
  };
};
